import React from 'react';

const DayHeader = ({ day }) => {
  const date = new Date(`${day}T00:00:00`);
  return (
    <div className='border-bottom bg-light px-2 py-2 text-center h-100'>
      <div className='text-uppercase text-muted' style={{ fontSize: '0.7rem' }}>
        {date.toLocaleDateString(undefined, { weekday: 'short' })}
      </div>
      <div className='fw-semibold'>{date.toLocaleDateString(undefined, { day: '2-digit', month: 'short' })}</div>
    </div>
  );
};

export default DayHeader;
